/* unplugin-vue-components disabled */import script from "./HomeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=4c60914e&lang=scss&scoped=true"

import exportComponent from "F:\\hjd\\dev\\yf-dsj\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c60914e"]])

export default __exports__